<template>
  <div>
    <widget title="Başvurular">

      <div class="row">
        <div class="col">
          <select class="form-control" v-model="form.type">
            <option value="1">Tamamlanan Başvurular</option>
            <option value="2">İptal Başvurular</option>
          </select>
        </div>
        <div class="col-2">

        </div>
        <div class="col">
          <input type="text" class="form-control"></input>
        </div>

      </div>

      <hr/>

      <el-table
        style="width: 100%"
      >
        <el-table-column
          label="İsim Soyisim"
          stripe
          width="300">
        </el-table-column>
        <el-table-column
          label="Tc Kimlik No"
          width="180">
        </el-table-column>
        <el-table-column
          label="Telefon Numarası"
          width="180">
        </el-table-column>
        <el-table-column
          label="Kayıt Tarihi"
          width="180">
        </el-table-column>
        <el-table-column
          label="Taahhüt Bitiş Tarihi"
          width="180">
        </el-table-column>
        <el-table-column
          v-if="form.type === '2'"
          label="İptal Nedeni"
          width="300">
        </el-table-column>
        <el-table-column
          label="İşlemler"
          width="180">
        </el-table-column>


      </el-table>

      <hr/>
      <el-pagination
        background
        layout="prev, pager, next"
        :total="1000">
      </el-pagination>

    </widget>
  </div>
</template>

<script>
  export default {
    name: "List",
    data(){
      return {
        page:1,
        form:{
          type:1,
          searchTerm:null
        }
      }
    },
    created() {

    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/BundleApplication/Page/List.vue